import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AdminLogin() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(t("admin.invalid"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
        <a href="/" className="block">
          <div className="font-script text-5xl leading-tight">Harry's</div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#5C5C59] mt-2 font-medium">
            Salotto &amp; Cucina
          </div>
        </a>

        <h1 className="font-serif text-3xl tracking-tight mt-12">{t("admin.login")}</h1>

        <label className="block mt-10">
          <span className="text-xs tracking-[0.2em] uppercase text-[#5C5C59] font-semibold">{t("admin.email")}</span>
          <input
            data-testid="admin-email"
            required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-transparent border-0 border-b border-[#E5E3D8] focus:border-[#8B3A3A] outline-none py-3"
          />
        </label>
        <label className="block mt-6">
          <span className="text-xs tracking-[0.2em] uppercase text-[#5C5C59] font-semibold">{t("admin.password")}</span>
          <input
            data-testid="admin-password"
            required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-transparent border-0 border-b border-[#E5E3D8] focus:border-[#8B3A3A] outline-none py-3"
          />
        </label>

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-signin"
          className="mt-10 w-full px-7 py-4 bg-[#8B3A3A] text-white hover:bg-[#6C2A2A] transition-all hover:-translate-y-[1px] disabled:opacity-60"
        >
          {loading ? "…" : t("admin.signin")}
        </button>
      </form>
    </div>
  );
}
